// TopContentTable — renders top promos / reels with thumbnails and stats.
// Columns are configurable so the same component handles both.
import React from 'react';
import { B } from '../constants';
import { formatNumber } from './StatCard';

const NUM_FORMATTER = (v) => formatNumber(typeof v === 'number' ? v : 0);

export default function TopContentTable({ title, rows, columns, emptyMessage = 'Nothing here yet.' }) {
  return (
    <section style={{ marginBottom: 24 }}>
      <h2 style={{
        fontFamily: "'Playfair Display',serif", color: B.night, fontSize: 22, marginBottom: 12,
      }}>
        {title}
      </h2>
      {rows.length === 0 ? (
        <p style={{ color: B.muted, fontFamily: "'Montserrat',sans-serif" }}>{emptyMessage}</p>
      ) : (
        <div style={{
          background: '#fff', borderRadius: 12, overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'Montserrat',sans-serif" }}>
            <thead>
              <tr style={{ background: B.sand, color: B.muted, fontSize: 11, textTransform: 'uppercase', letterSpacing: 1 }}>
                <th style={{ textAlign: 'left', padding: '10px 12px' }}>Title</th>
                {columns.map((c) => (
                  <th key={c.key} style={{ textAlign: 'right', padding: '10px 12px' }}>{c.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} style={{ borderTop: `1px solid ${B.sand}` }}>
                  <td style={{ padding: '10px 12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      {r.thumbnailUrl && (
                        <img
                          src={r.thumbnailUrl} alt=""
                          style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6 }}
                        />
                      )}
                      <div>
                        <div style={{ color: B.night, fontWeight: 600, fontSize: 14 }}>{r.title || '(untitled)'}</div>
                        {r.destination && (
                          <div style={{ color: B.muted, fontSize: 12 }}>{r.destination}</div>
                        )}
                      </div>
                    </div>
                  </td>
                  {columns.map((c) => (
                    <td key={c.key} style={{ textAlign: 'right', padding: '10px 12px', color: B.night, fontSize: 13 }}>
                      {(c.formatter || NUM_FORMATTER)(r[c.key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
